"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RootCategoryCard = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _carditem = require("../carditem");

var _style = require("./style");

var _lodash = _interopRequireDefault(require("lodash.isfunction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const RootCategoryCard = props => {
  const {
    header,
    title,
    subtitle,
    width,
    height,
    data,
    children,
    showLineSeparator,
    hoverState,
    onSelect,
    isSelected,
    ...rest
  } = props;
  const [selected, setSelected] = (0, _react.useState)(isSelected);

  const handleCardSelect = () => {
    (0, _lodash.default)(onSelect) && onSelect(props);
  };

  (0, _react.useEffect)(() => {
    setSelected(isSelected);
  }, [isSelected]);
  return /*#__PURE__*/_react.default.createElement(_style.StyledRootCard, _extends({}, rest, {
    hoverState: hoverState,
    selected: selected,
    width: width,
    height: height,
    onClick: handleCardSelect
  }), /*#__PURE__*/_react.default.createElement(_style.StyledContent, {
    tabIndex: "-1"
  }, /*#__PURE__*/_react.default.createElement(_style.StyledRootHeader, {
    borderBottom: showLineSeparator
  }, header && /*#__PURE__*/_react.default.createElement(_style.StyledHeader, null, header), title && /*#__PURE__*/_react.default.createElement(_style.StyledTitle, null, title), subtitle && /*#__PURE__*/_react.default.createElement(_style.StyledSubtitle, null, subtitle)), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children ? children : data && data.length > 0 && data.map((obj, i) => /*#__PURE__*/_react.default.createElement(_carditem.CategoryItem, _extends({
    key: i
  }, obj))))));
};

exports.RootCategoryCard = RootCategoryCard;
RootCategoryCard.defaultProps = {
  showLineSeparator: true,
  width: '270px',
  hoverState: true,
  isSelected: false
};
RootCategoryCard.propTypes = {
  /** Header Text for card */
  header: _propTypes.default.string.isRequired,

  /** title for card */
  title: _propTypes.default.string.isRequired,

  /** subtitle for card */
  subtitle: _propTypes.default.string.isRequired,

  /** width of card */
  width: _propTypes.default.string,

  /** height of card */
  height: _propTypes.default.string,

  /** hoverState will enable hover state for Card, default: true */
  hoverState: _propTypes.default.bool,

  /** onSelect is callback function, which will enable selection of each card  */
  onSelect: _propTypes.default.func,

  /** isSelected is Bool to set selected border   */
  isSelected: _propTypes.default.bool,

  /** use data prop with same structure */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  })),

  /** show or hide line separator */
  showLineSeparator: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
};